module.exports = __webpack_public_path__ + "static/Evaluation-d34682284c2b413eb4185d49605fbb85.pdf";